export default {
    PaletteFooter: {
        backgroundColor: "#fff",
        height: "5vh",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        fontWeight: "700"
    },
    emoji: {
        fontSize: "1.5rem",
        margin: "0 2rem 0 1rem"
    }
}